<div [hidden]="isLoading">
  @if (sections?.length) {
    <div>
      <div class="title">
        <button (click)="goBack()" mat-icon-button>
          <mat-icon>close</mat-icon>
        </button>
        <span>Edit form for {{ item.name }}</span>
      </div>
      <cotecna-nf-form
        #naturalForm
        [config]="formConfig"
        [sections]="sections"
        [controls]="controls"
        >
      </cotecna-nf-form>
    </div>
  } @else {
    <div id="empty-item">
      <mat-icon>sentiment_dissatisfied</mat-icon>
      This item has an empty form.
    </div>
  }

</div>
@if (isLoading) {
  <mat-spinner diameter="32"></mat-spinner>
}
